import React, { forwardRef, useEffect, useId, useRef, useState } from 'react';
import cx from "classnames";
import styled from "styled-components";
import IBuildrProps from '../../../utilities/IBuildrProps';
import { AutomationTestIdElementType, AutomationTestIdFeature, createDataTestId } from '../../../utilities/automation';

interface IInputTextareaProps extends IBuildrProps {
    inputLabel: string;
    inputPlaceholder?: string;
    inputDefaultValue: string;
    inputFieldName: string;
    inputRequired: boolean;
    hintText?: string;
    className?: string;
    inputClassName?: string;
    rows?: number;
    isWhite: boolean;
}

export default styled(forwardRef(function InputText({ inputLabel, inputPlaceholder = '', inputDefaultValue, inputFieldName, inputRequired, hintText = '', className = '', inputClassName = '', cmsId, rows = 5, editorClassObj, isWhite }: IInputTextareaProps, ref: any) {
    const [value, setValue] = useState(inputDefaultValue);
    const id = useId();
    useEffect(() => {
        setValue(inputDefaultValue || '');
    }, [inputDefaultValue]);

    return (
        <div data-id={cmsId} ref={ref} className={cx('form-group', className, editorClassObj)}>
            <h5 className={cx("title", {"text-white": isWhite})}><label className="m-0" htmlFor={id}>{inputLabel}</label></h5>
            <textarea
                id={id}
                className={cx("form-control", inputClassName, {"text-white": isWhite})}
                placeholder={inputPlaceholder}
                title={inputLabel}
                name={inputFieldName}
                required={inputRequired}
                value={value}
                onChange={e => setValue(e.target.value)}
                rows={rows}
                data-test-id={createDataTestId({ feature: AutomationTestIdFeature.FORM, element: AutomationTestIdElementType.INPUT, specifier: "textarea" })}></textarea>
            {hintText ? <div><small>{hintText}</small></div> : null}
        </div>
    )
}))`
.title {
    font-size: 0.88889rem;
    font-weight: 500;
    line-height: 1rem;
    margin-bottom: 0.44rem;
    color: var(--mud, #5E514D);
}
textarea {
    padding-left: 0;
    padding-right: 0;
    &::placeholder {
        color: var(--carbon);
        opacity: 0.3;
    }
    &.text-white {
        &::placeholder {
            color: white;
            opacity: 0.3;
        }
    }
}
`;
